import { create } from "zustand";
import { fetchCapabilities, IS_ADMIN_HOST } from "@/lib/auth";
import type { AuthState, Capabilities } from "@/lib/types";

interface AuthStore extends AuthState {
  load: () => Promise<void>;
}

// Minimal auth store. On Dyno v1 the admin role is inferred from:
//   - the host being admin-dyno.*  (IS_ADMIN_HOST)
//   - capabilities endpoint authenticated successfully
// Client role = session cookie present but host is public dyno.*
// Unknown = no auth yet (show login CTA)
export const useAuth = create<AuthStore>((set) => ({
  role: "unknown",
  isAdminHost: IS_ADMIN_HOST,
  capabilities: null,
  windowIds: null,
  load: async () => {
    const caps: Capabilities | null = await fetchCapabilities();
    if (!caps) {
      set({ role: "unknown", capabilities: null });
      return;
    }
    // CF Access on admin.* means authenticated users here are admins.
    // On dyno.*, any authenticated session is a client.
    set({
      role: IS_ADMIN_HOST ? "admin" : "client",
      capabilities: caps,
    });
  },
}));
